import { FormattedMessage } from "react-intl";
import type { Comparable } from "@/components/comparison/comparable";
import { TeamMemberPicker } from "@/components/match/TeamMemberPicker";
import { PersonLink } from "@/components/common/PersonLink";
import { Permission } from "@/auth/access-permissions";
import { useProfileComparisonStore, type ComparisonSelection } from "@/stores/profile-comparison-store";

export const profileComparable: Comparable<ComparisonSelection> = {
  kind: "profile", permission: Permission.CompareProfiles, path: "/p/compare", searchPath: "/extended-search", messages: {
    tools: "profile.compare.tools",
    remove: "profile.compare.remove",
    select: "profile.compare.select",
    removeDescription: "profile.compare.removeDescription",
    selectDescription: "profile.compare.selectDescription",
    count: "profile.compare.count",
    full: "profile.compare.full",
    removeName: "profile.compare.removeName",
    title: "profile.compare.title",
    addItem: "profile.compare.addItem",
    denied: "profile.compare.denied",
    empty: "profile.compare.empty",
    search: "profile.compare.search",
    loading: "profile.compare.loading",
    retry: "profile.compare.retry",
    unavailable: "profile.compare.unavailable",
  },
  useSelection: useProfileComparisonStore,
  identity: (person) => <PersonLink person={person} size="sm" className="max-w-48 rounded-full py-1 pl-1 pr-2 text-smycles-label focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-ui" />,
  picker: (props) => <TeamMemberPicker open idPrefix="profile-comparison-picker" title={<FormattedMessage id="profile.compare.addPerson" />} {...props} onPick={(person) => props.onPick({ id: person.id, name: person.name, avatarContent: person.avatarContent, avatarMime: person.avatarMime })} />,
};
